<template>
  <v-container fluid class="fixedasset-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/fixedasset/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="fixedassets-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="fixedassetHeaders"
              :items="fixedassets"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteFixedAsset"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Fixed Asset?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_fixedasset.assetcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteFixedAsset = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteFixedAsset(delete_fixedasset)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.assetstatus="{ item }">
                <v-chip
                  :color="!item.assetstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.assetstatus }}
                </v-chip>
              </template>
              <template v-slot:item.assettype="{ item }">
                <p class="two-line">{{ item.assettype }}</p>
                <p class="two-line">{{ item.deptype }}</p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editFixedAsset(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FixedAssetList',
  data() {
    return {
      isDeleteFixedAsset: false,
      isLoading: false,
      delete_fixedasset: {},
      item_seleted: [],
      fixedassetHeaders: [
        { text: 'Code', value: 'assetcode'},
        { text: 'Name', value: 'assetname'},
        { text: 'Type', value: 'assettype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('FixedAsset', ['fixedassets', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getFixedAssetsRequest();
  },
  methods: {
    ...mapActions('FixedAsset', ["deleteFixedAssetRequest","getFixedAssetsRequest"]),
    editFixedAsset(item) {
      this.$router.push({name: 'FixedAssetEdit', params: item});
    },
    deleteFixedAsset(item) {
      this.deleteFixedAssetRequest({_id: item._id});
      this.isDeleteFixedAsset = false;
    },
    deleteDialog(item) {
      this.isDeleteFixedAsset = true;
      this.delete_fixedasset = {_id: item._id,assetcode: item.assetcode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
